module.exports = __webpack_public_path__ + "img/p1.da2159b6.jpg";